import {
  Avatar, Button, Card, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, IconButton,
  Input, List, ListItem, ListItemAvatar, ListItemSecondaryAction, ListItemText, Paper, Select, Snackbar, Tooltip, Typography, createMuiTheme,
  CardContent,CardHeader
} from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import DateRangeIcon from '@material-ui/icons/DateRange';
import { green, red } from '@material-ui/core/colors';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import ArrowForwardIcon from '@material-ui/icons/ArrowForwardOutlined';
import ClearIcon from '@material-ui/icons/Clear';
import DoneIcon from '@material-ui/icons/Done';
import EmojiTransportationIcon from '@material-ui/icons/EmojiTransportation';
import FastfoodIcon from '@material-ui/icons/Fastfood';
import PhoneInTalkIcon from '@material-ui/icons/PhoneInTalk';
import PlayCircleFilledWhiteIcon from '@material-ui/icons/PlayCircleFilledWhite';
import RefreshIcon from '@material-ui/icons/Refresh';
import RoomIcon from '@material-ui/icons/Room';
import SearchIcon from '@material-ui/icons/Search';
import SettingsBackupRestoreIcon from '@material-ui/icons/SettingsBackupRestore';
import SettingsInputAntennaIcon from '@material-ui/icons/SettingsInputAntenna';
import ThumbUpIcon from '@material-ui/icons/ThumbUp';
import ThumbUpDownIcon from '@material-ui/icons/ThumbDown';
import WorkIcon from '@material-ui/icons/Work';
import { makeStyles, ThemeProvider } from '@material-ui/styles';
import clsx from 'clsx';
import moment from 'moment';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { confirmAlert } from 'react-confirm-alert';
import 'react-confirm-alert/src/react-confirm-alert.css';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { useHistory } from 'react-router';
import { Link as RouterLink } from 'react-router-dom';
import Alert from 'src/components/Alert';
import axios from 'src/utils/axios';
import { openBlob, sc, getUser } from 'src/utils/Common';
import { removeBaslandiJob } from 'src/utils/storage/StartWorkOrder';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import DateFnsUtils from '@date-io/date-fns';
import trLocale from 'date-fns/locale/tr';
import { setClosedJobs } from '../../store/actions/taskActions';
import FgsArama from './FgsCall';
import LocalCafeIcon from '@material-ui/icons/LocalCafe';
import PriorityHighIcon from '@material-ui/icons/PriorityHigh';
import InfoIcon from '@material-ui/icons/Info';

let MesafeSonuc = 0;


const useStyles = makeStyles((theme) => ({
  root: {},
  avatarAtanan: {
      backgroundColor: red[500],
      width: theme.spacing(4),
      height: theme.spacing(4),
  },
  avatar1Atanan: {
      backgroundColor: green[500],
      width: theme.spacing(4),
      height: theme.spacing(4),
  },
  valueAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  typeAtanan: {
    fontWeight: theme.typography.fontWeightMedium
  },
  searchAtanan: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconAtanan: {
    marginRight: theme.spacing(2),
    color: theme.palette.icon
  },
  searchInputAtanan: {
    flexGrow: 1
  },
  pageStyleAtanan: {
    display: 'flex',
    padding: '2px 4px',
  },
  inputAtanan: {
    marginLeft: theme.spacing(1),
    flex: 1,
  },
  iconButtonAtanan: {
    padding: 10,
  },
  dividerAtanan: {
    backgroundColor: '#1D3343'
  },
  fieldsAtanan: {
    margin: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    '& > *': {
      flexGrow: 1,
      margin: theme.spacing(1)
    }
  },
  moreButtonContainer: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: theme.spacing(2),
    },
    moreButton: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.primary.main,
      backgroundColor: theme.palette.background.paper,
      border: `1px solid ${theme.palette.primary.main}`,
      borderRadius: theme.shape.borderRadius,
      padding: theme.spacing(1, 2),
      '&:hover': {
        backgroundColor: theme.palette.primary.light,
        color: theme.palette.background.paper,
      },
    },
  urgentButton: {
    marginLeft: theme.spacing(-1),
    display: 'flex',
    flexWrap: 'wrap',
    color: '#b2102f'
  }
}));
const siyah = '#424242';
const materialTheme = createMuiTheme({
  palette: {
    primary: {
      contrastText: '#FFFFFF',
      dark: siyah,
      main: siyah,
      light: siyah
    },
  },
});
const localeMap = {
  tr: trLocale,
};
function Notifications({
  className, AtananIsler, handleRefresh, loading, setTask
}) {
  const classes = useStyles();
  const { t } = useTranslation('overview');
  const [filter, setFilter] = useState('');
  const [stateDurum, setStateDurum] = useState('');
  const [stateWarranty, setStateWarranty] = useState('');
  const [ReceiptNo, setReceiptNo] = useState('');
  const [open, setOpen] = React.useState(false);
  const [rejectOpen, setRejectOpen] = React.useState(false);
  const [rejectJob, setRejectJob] = React.useState();
  const [confirmJob, setconfirmJob] = React.useState();
  const [confirmnewStatus, setconfirmnewStatus] = React.useState();
  const [Enlem, setEnlem] = useState('');
  const [Boylam, setBoylam] = useState('');
  // const [MesafeSonuc, setMesafeSonuc] = useState("");
  const locale = localStorage.getItem('i18nextLng');
  const [responseMessage, setresponseMessage] = useState({ ErrorCode: '0', ErrorDescription: t('success_message') });
  const [uyari, setUyari] = React.useState(false);
  const [uyariTip, setUyariTip] = React.useState();
  const [openFgsArama, setOpenFgsArama] = useState(false);
  const [ConfirmTitle, setConfirmTitle] = useState('');
  const [ConfirmDescription, setConfirmDescription] = useState('');
  const [confirmRejectTitle, setConfirmRejectTitle] = useState('');
  const [confirmRejectDescription, setConfirmRejectDescription] = useState('');
  const [loading2, setLoading2] = useState(false);
  const [loadingIOT, setLoadingIOT] = useState(false);
  const [sortedData, setSortedData] = useState([]);
  const [openChooseDate, setopenChooseDate] = useState(false);
  const history = useHistory();
  const [visibleItems, setVisibleItems] = useState(10);
    const loadMore = () => {
      setVisibleItems(prevVisibleItems => prevVisibleItems + 10);
    };
  
  const today = new Date();

  const [StartDate, setStartDate] = useState(sessionStorage.getItem('ClosedJobsStartDate') ? sessionStorage.getItem('ClosedJobsStartDate') : today);
  const [EndDate, setEndDate] = useState(sessionStorage.getItem('ClosedJobsEndDate') ? sessionStorage.getItem('ClosedJobsEndDate') : today);

  const StartDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setStartDate(Deger);
    sessionStorage.removeItem('ClosedJobsStartDate');
    sessionStorage.setItem('ClosedJobsStartDate', Deger);
  };

  const EndDatehandleChange = (value) => {
    const Deger = moment(value).format('YYYY-MM-DD');
    setEndDate(Deger);
    sessionStorage.removeItem('ClosedJobsEndDate');
    sessionStorage.setItem('ClosedJobsEndDate', Deger);
  };

  const handleRefreshDate = (e) => {
    setopenChooseDate(false);
    handleRefresh();
  };

  const handleFgsAramaOpen = (event, AtananIsFisNo) => {
    setOpenFgsArama(true);
    setReceiptNo(AtananIsFisNo.toString());
  };
  const handleFgsAramaClose = () => {
    setOpenFgsArama(false);
  };
  const durumMap = new Map([
    [20, t('Başvuru')],
    [21, t('Teknisyende')],
    [22, t('Ustlendi')],
    [33, t('Baslandi')],
    [42, t('Yola_cikildi')]
  ]);
  const uyariKapat = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    setUyari(false);
  };
  const handleChange = (event) => {
    setStateDurum(event.target.value);
  };
  const handleChangeWarranty = (event) => {
    setStateWarranty(event.target.value);
  };
  const Kirmizi = {
    color: '#b2102f'
  };
  const Sari = {
    color: '#ffc107'
  };
  const Yesil = {
    color: '#357a38'
  };
  const Mavi = {
    color: '#007FFF'
  };
  const getRandevuColor = (Bas, Bit) => {
    const today = Date.now();
    const bitis = Date.parse(Bit);
    const saat = 1000 * 60 * 60;
    if (bitis > today + saat) {
      return Yesil;
    }
    if (bitis > today + saat / 2) {
      return Sari;
    }

    return Kirmizi;
  };
  const getAvatar = (AtananIs) => {
    const Bas = AtananIs.AppointmentBegin?.substring(12, 2);
    const Bit = AtananIs.AppointmentEnd;
    if ([21, 22, 33, 42].indexOf(parseInt(AtananIs.StatusCode)) === -1) {
      let Kontrol = '';
      const KontrolText = '';
      const KontrolText1 = '';
      if (AtananIs.AppointmentCloseDownControl === 1) {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatar1Atanan}>
            <DoneIcon />
          </Avatar>
        );
      } else {
        Kontrol = (
          <Avatar aria-label="recipe" className={classes.avatarAtanan}>
            <ClearIcon />
          </Avatar>
        );
      }
      return (
        <Typography
          component="span"
          variant="h6"
          style={Sari}
        >
          {Kontrol}
          <br />
          {KontrolText}
          <br />
          {KontrolText1}
        </Typography>
      );
    }

    return (
      <Typography
        component="span"
        variant="h6"
        style={getRandevuColor(Bas, Bit)}
      >
        <div>
          {AtananIs.AppointmentBegin?.substring(11, 16)}
          <br />
          {AtananIs.AppointmentEnd?.substring(11, 16)}
        </div>
      </Typography>
    );
  };

  const getIOT = (AtananIs) => {
    if (parseInt(AtananIs.Barcode) === 0) {
      return <div />;
    }
    return (
      <div>
        {loadingIOT ? <CircularProgress style={Mavi} status="loading" /> : <SettingsInputAntennaIcon style={Mavi} onClick={(event) => handleIOTClickOpen(AtananIs)} />}
        <br />
        <br />
      </div>
    );
  };

  const getDurum = (AtananIs) => {
    if (parseInt(AtananIs.ReceiptNo) === 0) {
      return <div />;
    }
    // if (AtananIs.StatusCode === 21 || AtananIs.StatusCode === 63) {
    //   return <ThumbUpIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 22)} />;
    // } if (AtananIs.StatusCode === 22) {
    //   return <EmojiTransportationIcon color="secondary" onClick={(event) => handleClickOpen(AtananIs, 42)} />;
    // } if (AtananIs.StatusCode === 42) {
    //   return (
    //     <div>
    //       <ThumbUpIcon color="secondary" onClick={(event) => handleClickOpen(AtananIs, 22)} />
    //       <br />
    //       <br />
    //       <PlayCircleFilledWhiteIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 33)} />
    //     </div>
    //   );
    // }
  };

  const handleIOTClick = (AtananIs) => {
    setLoadingIOT(true);
    const Barkod = `${AtananIs.ModelCode + AtananIs.UYIL.toString().substring(2, 4).toString() + AtananIs.SERINO.toString().padStart(6, '0') + AtananIs.UDONEM.toString().padStart(2, '0')}01`;
    const configIOT = {
      responseType: 'blob',
      headers: { 'Content-Type': 'application/json' }
    };
    axios.get(`/FileImportExport/ArtemisIOT/${Barkod}`, configIOT)
      .then((response) => {
        if (response.data.type === 'text/plain') {
          setresponseMessage({ ErrorCode: 10, ErrorDescription: t('IOT_error') });
          setUyariTip('error');
          setUyari(true);
        } else {
          openBlob(response.data, Barkod);
        }
        setLoadingIOT(false);
      }).catch((error) => {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('IOT_error') });
        setUyariTip('error');
        setUyari(true);
        setLoadingIOT(false);
      });
  };

  const handleIOTClickOpen = (AtananIs) => {
    // var Uyari = AtananIs.FisNo + " fiş numaralı müşterimizin " + AtananIs.KUL_MODEL_KODU + ' ' + AtananIs.MODEL + ' Ürününe uzaktan bağlanılıp sağlık verilerine ulaşılacaktır. Devam etmek istediğinizdne eminmisiniz?';
    const Uyari = t('IOT_confirm').replace('@FisNo', AtananIs.ReceiptNo).replace('@KulModelKodu', AtananIs.ModelCode).replace('@Model', AtananIs.Model);
    confirmAlert({
      message: Uyari,
      buttons: [
        {
          label: 'Evet',
          onClick: () => handleIOTClick(AtananIs)
        },
        {
          label: 'Hayır',
          onClick: () => { }
        }
      ]
    });
  };

  const handleClickOpen = (job, newStatus) => {
    const options = {
      enableHighAccuracy: true,
      timeout: 5000,
      maximumAge: 0
    };
    function error(err) {
      const Uyari = '';
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.ReceiptNo} ${job.CustomerFullName}`);
      if (parseInt(job.ReceiptNo) === 0) {
        setConfirmTitle(`${job.CustomerFullName}`);
        if (newStatus === 33) {
          setConfirmDescription(t('yemek_baslat'));
        }
        if (newStatus === 4) {
          setConfirmDescription(t('yemek_bitir'));
        }
      } else {
        // setConfirmDescription(`${Uyari} ${newStatusDesc} duruma almak istiyor musunuz?`);
        setConfirmDescription(t('durum_uyari').replace('@uyari', Uyari).replace('@newStatus', newStatusDesc));
      }
    }
    function success(position) {
      const X1 = job.ENLEM;
      const X2 = job.BOYLAM;
      let Uyari = '';
      let Y1 = '';
      let Y2 = '';
      Y1 = position.coords.latitude;
      Y2 = position.coords.longitude;
      setEnlem(Y1);
      setBoylam(Y2);
      const MesafeSonucAtanan = getDistanceFromLatLonInKm(X1, X2, Y1, Y2).toFixed(1);
      if (isNaN(MesafeSonucAtanan)) {
        MesafeSonuc = 0;
      } else {
        MesafeSonuc = MesafeSonucAtanan;
      }

      if (newStatus === 33 && parseInt(job.ReceiptNo) > 0) {
        if (MesafeSonucAtanan > 100) {
          // Uyari = "Müşteri evinden " + Math.floor(MesafeSonucAtanan) + " metre uzakta işi başlatmaya çalışıyorsunuz!!! İşi başlatmak istediğinize emin misiniz? Müşteri Enlem,Boylam:" + X1 + "," + X2 + " TeknisyenEnlem,Boylam: " + Y1 + ", " + Y2 + " ";
          Uyari = t('mesafe_uyari').replace('@MesafeSonucAtanan', Math.floor(MesafeSonucAtanan)).replace('@X1', X1).replace('@X2', X2)
            .replace('@Y1', Y1)
            .replace('@Y2', Y2);
        }
      }
      setOpen(true);
      setconfirmJob(job);
      setconfirmnewStatus(newStatus);
      const newStatusDesc = durumMap.get(newStatus);
      setConfirmTitle(`${job.ReceiptNo} ${job.CustomerFullName}`);

      if (parseInt(job.ReceiptNo) === 0) {
        setConfirmTitle(`${job.CustomerFullName}`);
        if (newStatus === 33) {
          setConfirmDescription(t('yemek_baslat'));
        }
        if (newStatus === 4) {
          setConfirmDescription(t('yemek_bitir'));
        }
      } else {
        setConfirmDescription(t('durum_uyari').replace('@uyari', Uyari).replace('@newStatus', newStatusDesc));
      }
    }

    navigator.geolocation.getCurrentPosition(success, error, options);
  };

  const handleClickRejectOpen = (jobId) => {
    setConfirmRejectTitle(`${jobId}`);
    setConfirmRejectDescription(t('reject_message').replace('@Recipient', jobId));
    setRejectJob(jobId);
    setRejectOpen(true);
  };

  const handleClickReject = (jobId) => {
    axios.post(`/SetWorkOrderReject/${jobId}`)
      .then((response) => {
        const ResponseData = response.data;
        if (ResponseData.ErrorCode === '0') {
          setUyariTip('success');
          setSortedData(AtananIsler.map((item) => (item.ReceiptNo === jobId
            ? {
              ...item,
              StatusCode: ResponseData.StatusId,
              Durum: ResponseData.StatusDesc,
              DURUM_KODU: ResponseData.StatusId,
            }
            : item)));
          handleRefresh();
        } else {
          setUyariTip('error');
          setresponseMessage({ ErrorCode: ResponseData.ErrorCode, ErrorDescription: ResponseData.ErrorDescription });
        }
        setUyari(true);
        setRejectOpen(false);
        setLoading2(false);
      })
      .catch((error) => {
        let ErrorData = '';
        ErrorData = t('offline_messsage');
        setUyariTip('error');
        setUyari(true);
        setRejectOpen(false);
        setLoading2(false);
      });
  };


  function getDistanceFromLatLonInKm(lat1, lon1, lat2, lon2) {
    const R = 6371; // Radius of the earth in km
    const dLat = deg2rad(lat2 - lat1); // deg2rad below
    const dLon = deg2rad(lon2 - lon1);
    const a = Math.sin(dLat / 2) * Math.sin(dLat / 2)
      + Math.cos(deg2rad(lat1)) * Math.cos(deg2rad(lat2))
      * Math.sin(dLon / 2) * Math.sin(dLon / 2);
    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    const d = R * c; // Distance in km
    return d * 1000;
  }
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }

  const statusUpdate = (job, newStatus) => {
    const SessionUser = getUser();
    setOpen(false);
    setLoading2(true);
    const newStatusDesc = durumMap.get(newStatus);


    if (newStatus === 33) {
      const baslananIsler = AtananIsler.filter((d) => parseInt(d.StatusCode) === parseInt(33)
        && parseInt(d.ReceiptNo) !== parseInt(job.ReceiptNo));

      if (baslananIsler.length > 0) {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('baslandi_error').replace('@FisNo', baslananIsler[0].ReceiptNo) });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }
    }
    if (newStatus === 42) {
      const yolaCikildiIsler = AtananIsler.filter((d) => parseInt(d.StatusCode) === parseInt(42)
        && parseInt(d.ReceiptNo) !== parseInt(job.ReceiptNo));

      if (yolaCikildiIsler.length > 0) {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('yola_cikildi_error').replace('@FisNo', yolaCikildiIsler[0].ReceiptNo) });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }

      const baslananIslerYolaCikildi = AtananIsler.filter((d) => parseInt(d.StatusCode) === parseInt(33)
        && parseInt(d.ReceiptNo) !== parseInt(job.ReceiptNo));

      if (baslananIslerYolaCikildi.length > 0) {
        setresponseMessage({ ErrorCode: 10, ErrorDescription: t('baslandi_error').replace('@FisNo', baslananIslerYolaCikildi[0].ReceiptNo) });
        setUyariTip('error');
        setUyari(true);
        setLoading2(false);
        return;
      }
    }

    const OperationDateParam = moment().utcOffset('+03:00');


    if (isNaN(MesafeSonuc)) {
      MesafeSonuc = 0;
    }

    const data = [{
      AppNr: job.ReceiptNo,
      ServicePaperId: job.ReceiptNo,
      ServiceShopId: SessionUser.ServiceShopId,
      RequestStatus: newStatus,
      ResultNote: '',
      TechnicianId: SessionUser.TechnicianId,
      DeviceStatus: job.StatusCode,
      Latitude: Enlem.toString(),
      Longitude: Boylam.toString(),
      OperationDate: OperationDateParam,
      Distance: Math.floor(MesafeSonuc),
    }];
    const config = {
      headers: { 'Content-Type': 'application/json' }
    };

    axios.post('/SetSiriusWorkOrderStatusUpdate', data, config)
      .then((response) => {
        const ResponseData = response.data[0];
        setresponseMessage(ResponseData);
        if (ResponseData.ErrorCode === '0') {
          setUyariTip('success');
          if (newStatus === 33 && parseInt(job.ReceiptNo) > 0) {
            setClosedJobs({
              ...job, StatusCode: newStatus, Durum: newStatusDesc, DURUM_KODU: newStatus,
            });
            history.push(`/WorkOrder/${job.ReceiptNo}/summary`);
          }
          setSortedData(AtananIsler.map((item) => (item.ReceiptNo === job.ReceiptNo
            ? {
              ...item,
              StatusCode: newStatus,
              Durum: newStatusDesc,
              DURUM_KODU: newStatus,
            }
            : item)));
          handleRefresh();
        } else {
          setUyariTip('error');
        }
        setUyari(true);
        setOpen(false);
        setLoading2(false);
      })
      .catch((error) => {
        let ErrorData = '';
        ErrorData = t('offline_messsage');
        setresponseMessage({ ErrorCode: '1000', ErrorDescription: ErrorData });
        setUyariTip('error');
        setUyari(true);
        setOpen(false);
        setLoading2(false);
      });
  };

  const handleClick = (event, AtananIs) => {
    window.open(`${process.env.REACT_APP_MAP_URL + AtananIs.Latitude},${AtananIs.Longitude}`);
    event.persist();
  };

  const handleOpenDate = () => {
    setopenChooseDate(true);
    setConfirmTitle(t('lblTarihSecimi'));
  };

  useEffect(() => {
    const uniqueValueSet = new Set();
    const distinctValues = [];
    if(stateDurum === '' && stateWarranty === ''){
      setSortedData(AtananIsler)
      return;
    }
    if(stateDurum !== '' && stateWarranty !== ''){
      AtananIsler.forEach(item =>{
        if (!uniqueValueSet.has(item.ReceiptNo) && item.StatusCode == stateDurum && item.WarrantyTypeId ==  stateWarranty)
         {
          uniqueValueSet.add(item.ReceiptNo);
          distinctValues.push(item);
        }
      })
    }
    else{
      AtananIsler.forEach(item =>{
        if (stateDurum !== '' && !uniqueValueSet.has(item.ReceiptNo) && item.StatusCode == stateDurum)
         {
          uniqueValueSet.add(item.ReceiptNo);
          distinctValues.push(item);
        }
        if (stateWarranty !== '' && !uniqueValueSet.has(item.ReceiptNo) && item.WarrantyTypeId == stateWarranty)
         {
          uniqueValueSet.add(item.ReceiptNo);
          distinctValues.push(item);
        }
      })
    }
    setSortedData(distinctValues);
    
  }, [stateDurum,stateWarranty, AtananIsler]);

  useEffect(() => {
    const filteredData = filter === ''
      ? [...AtananIsler]
      : AtananIsler.filter((item) =>
          sc(item.CustomerFullName, filter) || sc(item.BASVURU_NOTU, filter) || sc(item.ReceiptNo, filter) ||
          sc(item.BasvuruNedeni, filter) || sc(item.Mahalle, filter) || sc(item.Telefon, filter) || sc(item.Randevu, filter)
          || sc(item.WorkCaseId, filter)
        );
  
    const sortedData = [...filteredData].sort((a, b) => {
      const dateA = new Date(moment(a.AppointmentDate).format('YYYY-MM-DD HH:mm'));
      const dateB = new Date(moment(b.AppointmentDate).format('YYYY-MM-DD HH:mm'));
  
      return dateA - dateB;
    });
  
   setSortedData(sortedData);
  }, [filter, AtananIsler]);

   // AtananIsler dizisinden benzersiz değerleri içeren bir Set oluştur
  const uniqueValuesSet = new Set();
  const distinctAtananIsler = [];
  const uniqueWarrantySet = new Set();
  const distinctWarrantyData = [];
  
  AtananIsler.forEach(item => {
    if (!uniqueValuesSet.has(item.Status)) {
      uniqueValuesSet.add(item.Status);
      distinctAtananIsler.push(item);
    }
    if (!uniqueWarrantySet.has(item.WarrantyTypeText)) {
      uniqueWarrantySet.add(item.WarrantyTypeText);
      distinctWarrantyData.push(item);
    }
    });

    useEffect(() => {
      if (open) {
        document.body.style.overflow = 'hidden';
      } else {
        document.body.style.overflow = 'auto';
      }
    }, [open]);

  return (
    <div>
      <Snackbar
        open={uyari}
        autoHideDuration={10000}
        style={{ paddingTop: 90 }}
        onClose={uyariKapat}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={uyariKapat} message={responseMessage.ErrorDescription} variant={uyariTip} />
      </Snackbar>
      <Paper component="form" className={classes.pageStyleAtanan}>
       <Select
          native
          value={stateDurum}
          disableUnderline
          className={classes.inputAtanan}
          onChange={handleChange}
          label="Durum"
        >
          <option aria-label="None" value="">{t('ddl_Tumu')}</option>
          {distinctAtananIsler.length !== 0 ? distinctAtananIsler.map((item, index) => (
            <option key={index} value={item.StatusCode}>{item.Status}</option>
          )) : ''}
        </Select>
        <Select
           native
           value={stateWarranty}
           disableUnderline
           className={classes.inputAtanan}
           onChange={handleChangeWarranty}
           label="Warranty"
         >
             <option aria-label="None" value="">{t('ddl_Warranty')}</option>
             {distinctWarrantyData.length !== 0 ?  distinctWarrantyData.map((item) => (
               <option key={item.WarrantyTypeId} value={item.WarrantyTypeId}>{item.WarrantyTypeText}</option>
             )) : ''}  
        </Select>
        <IconButton
          color="primary"
          onClick={handleRefresh}
          className={classes.iconButtonAtanan}
          aria-label="directions"
        >
          <RefreshIcon />
        </IconButton>
        <IconButton
          color="primary"
          onClick={() => {
            removeBaslandiJob();
          }}
          className={classes.iconButtonAtanan}
          aria-label="directions"
        >
          <SettingsBackupRestoreIcon />
        </IconButton>
        <IconButton
          color="primary"
          onClick={handleOpenDate}
          className={classes.iconButtonAtanan}
          aria-label="directions"
        >
          <DateRangeIcon />
        </IconButton>
      </Paper>
      <Card className={clsx(classes.root, className)}>
        <CardHeader title={t('lblHistoricalJobs')} style={{textAlign:'left'}} />
        <Divider />
        <Paper
          className={classes.searchAtanan}
          elevation={1}
        >
          <SearchIcon
            className={classes.searchIconAtanan}
          />
          <Input
            className={classes.searchInputAtanan}
            disableUnderline
            onChange={(event) => { setFilter(event.target.value); }}
            placeholder={t('search')}
          />
        </Paper>
        {
          loading || loading2 ? <CircularProgress status="loading" />
            : (
              AtananIsler?.length !== 0 ?
                <List>
                  {sortedData
                    .sort((a, b) => a.SIRA - b.SIRA)
                    .slice(0, visibleItems)
                    .map((AtananIs) => (
                    <div key={AtananIs.ReceiptNo}>
                      {AtananIs.PotentialLiabilityActive === 1 ?
                        <Grid container direction="row" justify='flex-end' alignItems='center'>
                          <InfoIcon style={{ color: '#CD0404' }} /><Typography style={{ color: '#CD0404', margin: '10px' }} variant="h6" display="block" gutterBottom>
                            {t('lblPotentialLiabilityClaim')}!</Typography>
                        </Grid>
                        : ''}
                      <ListItem>
                        <ListItemAvatar>
                          <div>
                            {parseInt(AtananIs.PAKET) === 1 && <AccountTreeIcon color="primary" />}
                            {/* {getIOT(AtananIs)} */}
                            {getAvatar(AtananIs)}
                            <br />
                            {getDurum(AtananIs)}
                            <br />
                          {/*
                          (AtananIs.StatusCode == 21 || AtananIs.StatusCode == 22 || AtananIs.StatusCode == 42 || AtananIs.StatusCode == 33) ? 
                            <ThumbUpDownIcon style={Kirmizi} onClick={(event) => handleClickRejectOpen(AtananIs.ReceiptNo)} /> : ''
                          */}
                          </div>
                        </ListItemAvatar>
                        <ListItemText>
                          <Grid container direction="row-reverse"
                            justify="flex-start"
                            alignItems="center">
                            <Grid item>
                              {AtananIs.UrgentCustomer === 1 &&
                                (<Tooltip title={t('lblUrgentCustomer')}>
                                  <PriorityHighIcon className={classes.urgentButton} />
                                </Tooltip>)}
                            </Grid>
                          </Grid>
                          <Typography
                            variant="body1"
                            component={RouterLink}
                            to={AtananIs.ReceiptNo > 0 ? `/WorkOrder/${AtananIs.ReceiptNo}/summary` : '#'}
                          >

                            {/* <span className={classes.valueAtanan}>{AtananIs.ReceiptNo}</span> */}
                            {' '}
                            <span className={classes.typeAtanan}>
                              <b>{AtananIs.AppointmentDate?.substring(0, 10)}</b>
                              <br />
                              { t('lblWorkOrder')  }  {`:${AtananIs.ReceiptNo}`}
                              <br/>
                              { t('lblWorkCase')  }  {`:${AtananIs.WorkCaseId}`}
                              <br />
                              {AtananIs.CustomerFullName}
                              <br/>
                              {AtananIs.CustomerType}
                              <br />
                              {AtananIs.IssueReason}
                              <br />
                              {AtananIs.Neighborhood}
                              -
                              {AtananIs.Address}
                            </span>
                            <br />
                            {AtananIs.CallCenterNote}
                            <br />

                          </Typography>
                          <div className={classes.fieldsAtanan}>
                            <Grid container spacing={1}>
                              <Grid item xs={2}>
                                {parseInt(AtananIs.ReceiptNo) > 0
                                  ? <PhoneInTalkIcon color="secondary" onClick={(event) => handleFgsAramaOpen(event, AtananIs.ReceiptNo)} />
                                  : AtananIs.StatusCode === 22 && <FastfoodIcon style={Yesil} onClick={(event) => handleClickOpen(AtananIs, 33)} />}
                              </Grid>

                              <Grid item xs={8} align="center">
                                <Typography variant="h6">{AtananIs.Status}</Typography>
                              </Grid>
                              <Grid item xs={2} align="right">
                                {parseInt(AtananIs.ReceiptNo) > 0
                                  ? <RoomIcon color="secondary" onClick={(event) => handleClick(event, AtananIs)} />
                                  : AtananIs.StatusCode === 33 && <WorkIcon style={Kirmizi} onClick={(event) => handleClickOpen(AtananIs, 4)} />}
                              </Grid>
                            </Grid>
                          </div>
                        </ListItemText>
                        <ListItemSecondaryAction>
                          {parseInt(AtananIs.ReceiptNo) > 0
                            && (
                              <Tooltip title={t('lblDetaylariGoster')}>
                                <IconButton
                                  color="primary"
                                  component={RouterLink}
                                  to={`/WorkOrder/${AtananIs.ReceiptNo}/summary`}
                                  edge="end"
                                  size="small"
                                >
                                  <ArrowForwardIcon />
                                </IconButton>
                              </Tooltip>
                            )}
                        </ListItemSecondaryAction>
                      </ListItem>
                      <Divider className={classes.dividerAtanan} />
                    </div>
                  ))}
                  {visibleItems < sortedData.length && (
                    <div className={classes.moreButtonContainer}>
                      <Button className={classes.moreButton} onClick={loadMore}>
                        {t('lblMore')}
                        <ArrowDropDownIcon className={classes.icon} />
                      </Button>
                    </div>
                  )}
                </List>
                :
                (
                  <div>
                    <Divider />
                    <Card>
                      <CardContent className={classes.content}>
                        <Typography variant="h5" gutterBottom>
                          <br />
                          <br />
                          <LocalCafeIcon />
                          <br />
                          <br />
                          {t('lblHistoricalJobsMsg')}
                          <br />
                          <br />
                          <br />
                          <br />
                        </Typography>
                      </CardContent>
                    </Card>
                  </div>
                )
            )
        }
        <FgsArama
          onClose={handleFgsAramaClose}
          ReceiptNo={ReceiptNo}
          open={openFgsArama}
        />
      </Card>
      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {ConfirmTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {ConfirmDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => statusUpdate(confirmJob, confirmnewStatus)} color="primary">
            {t('Evet')}
          </Button>
          <Button onClick={() => setOpen(false)} color="primary" autoFocus>
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={openChooseDate}
        onClose={() => setopenChooseDate(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {ConfirmTitle}
        </DialogTitle>
        <Divider />
        <DialogContent>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BaslangiçTarihi"
                  label={t('BaslangicTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy"
                  variant="outlined"
                  value={StartDate}
                  onChange={(e) => StartDatehandleChange(e)}
                  maxDate={new Date(today.setDate(today.getDate()))}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
          <Typography variant="h6" component="h2" gutterBottom>
            <ThemeProvider theme={materialTheme}>
              <MuiPickersUtilsProvider utils={DateFnsUtils} locale={localeMap[locale]}>
                <KeyboardDatePicker
                  margin="normal"
                  color="primary"
                  inputVariant="outlined"
                  id="BitisTarihi"
                  label={t('BitisTarihi')}
                  invalidDateMessage={t('hatali_tarih')}
                  format="dd.MM.yyyy"
                  variant="outlined"
                  value={EndDate}
                  onChange={(e) => EndDatehandleChange(e)}
                  maxDate={new Date(today.setDate(today.getDate()))}
                  KeyboardButtonProps={{
                    'aria-label': 'change date',
                  }}
                />
              </MuiPickersUtilsProvider>
            </ThemeProvider>
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={(e) => handleRefreshDate(e)} color="primary" autoFocus>
            {t('Ok')}
          </Button>
        </DialogActions>
      </Dialog>
      <Dialog
        open={rejectOpen}
        onClose={() => setRejectOpen(false)}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle id="alert-dialog-title">
          {confirmRejectTitle}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-description">
            {confirmRejectDescription}
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={(event) => handleClickReject(rejectJob)} color="primary">
            {t('Evet')}
          </Button>
          <Button onClick={() => setRejectOpen(false)} color="primary" autoFocus>
            {t('Hayir')}
          </Button>
        </DialogActions>
      </Dialog>

    </div>
  );
}

Notifications.propTypes = {
  className: PropTypes.string
};

// export default Notifications;


export default connect(
  (state) => ({ loading: state.tasks1.loading }),
  { setClosedJobs }
)(Notifications);
